import { learningPathActionTypes } from './Constants';

export function toggleLearningPathCreateModal(data) {
	return {
		type: learningPathActionTypes.TOGGLE_LEARNING_PATH_CREATE_MODAL,
		payload: { data },
	};
}

export function getLearningPathOptions(data) {
	return {
		type: learningPathActionTypes.GET_LEARNING_PATH_OPTIONS,
		payload: { data },
	};
}

export function getLearningPathOptionsSuccess(data) {
	return {
		type: learningPathActionTypes.GET_LEARNING_PATH_OPTIONS_SUCCESS,
		payload: { data },
	};
}

export function getLearningPathOptionsError() {
	return {
		type: learningPathActionTypes.GET_LEARNING_PATH_OPTIONS_ERROR,
	};
}

export function createLearningPath(data, callback) {
	return {
		type: learningPathActionTypes.CREATE_LEARNING_PATH,
		payload: { data, callback },
	};
}

export function createLearningPathSuccess() {
	return {
		type: learningPathActionTypes.CREATE_LEARNING_PATH_SUCCESS,
	};
}

export function createLearningPathError() {
	return {
		type: learningPathActionTypes.CREATE_LEARNING_PATH_ERROR,
	};
}

export function manageLearningPathStep(id, data, callback) {
	return {
		type: learningPathActionTypes.MANAGE_LEARNING_PATH_STEP,
		payload: { id, data, callback },
	};
}

export function manageLearningPathStepFinal() {
	return {
		type: learningPathActionTypes.MANAGE_LEARNING_PATH_STEP_FINAL,
	};
}

export function closeLearningPath(id, callback) {
	return {
		type: learningPathActionTypes.CLOSE_LEARNING_PATH,
		payload: { id, callback },
	};
}

export function closeLearningPathFinal() {
	return {
		type: learningPathActionTypes.CLOSE_LEARNING_PATH_FINAL,
	};
}

export function clearModalState() {
	return {
		type: learningPathActionTypes.CLEAR_LEARNING_PATH_MODAL_STATE,
	};
}
